import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';

import { LoggedInGuard, UsaTurismo } from '../services';
import { PagesComponent } from './pages.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { PerfilComponent } from './perfil/perfil.component';
import { MeusOrcamentosComponent } from './meus-orcamentos/meus-orcamentos.component';
import { USA_TURISMO } from '../app.config';

const routes: Routes = [
  {
    path: "",
    component: PagesComponent,
    children: [
      {
        path: "dashboard",
        component: DashboardComponent,
        canActivate: [LoggedInGuard],
        data: { permissao: ['dashboard','agenteadmin']},
      },
      {
        path: "perfil",
        component: PerfilComponent,
        canActivate: [LoggedInGuard],
      },
      {
        path: "",
        redirectTo: USA_TURISMO ? "turismo/busca" : "cadastro/agencia",
        pathMatch: "full",
      },
      {
        path: "meus-orcamentos",
        component: MeusOrcamentosComponent,
        canActivate: [LoggedInGuard],
      },
      {
        path: "turismo",
        loadChildren: '../turismo/turismo.module#TurismoModule',
        // loadChildren: () => import("../turismo/turismo.module").then((m) => m.TurismoModule),
        canActivate: [LoggedInGuard, UsaTurismo],
        //data: { permissao: ['root','admin','agente']},
      },
      {
        path: "gerenciamento",
        loadChildren: '../gerenciamento/gerenciamento.module#GerenciamentoModule',
        // loadChildren: () => import("../gerenciamento/gerenciamento.module").then((m) => m.GerenciamentoModule ),
        canActivate: [LoggedInGuard],
        //data: { permissao: ['root','admin']},
      },
      {
        path: "cadastro",
        loadChildren: '../cadastro/cadastro.module#CadastroModule',  canActivate: [LoggedInGuard],   //data: { permissao: ['root','admin']},
        // loadChildren: () => import("../cadastro/cadastro.module").then((m) => m.CadastroModule),  canActivate: [LoggedInGuard],   //data: { permissao: ['root','admin']},
      },
      {
        path: "intranet",
        loadChildren:'../intranet/intranet.module#IntranetModule', canActivate: [LoggedInGuard],  //data: { permissao: ['root','admin']},
        // loadChildren: () =>   import("../intranet/intranet.module").then((m) => m.IntranetModule),      canActivate: [LoggedInGuard],      //data: { permissao: ['root','admin']},
      },
      {
        path: "configuracao",
        loadChildren: '../configuracao/configuracao.module#ConfiguracaoModule', canActivate: [LoggedInGuard], // data: { permissao: ["root", "admin"] },
        // loadChildren: () => import("../configuracao/configuracao.module").then((m) => m.ConfiguracaoModule ), canActivate: [LoggedInGuard],  data: { permissao: ["root", "admin"] },
      },
    ],
  },
];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})

export class PagesRoutingModule {}
